// extracted by mini-css-extract-plugin
export default {"description":"macroeconomic_description__hwc0e","content":"macroeconomic_content__vG9iE"};